/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Save_Time_Feature_3Inputs */

const en_homepage_save_time_feature_3 = /** @type {(inputs: Homepage_Save_Time_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of course, you can also listen to entire papers from top to bottom`)
};

const es_homepage_save_time_feature_3 = /** @type {(inputs: Homepage_Save_Time_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por supuesto, también puedes escuchar artículos completos de principio a fin`)
};

/**
* | output |
* | --- |
* | "Of course, you can also listen to entire papers from top to bottom" |
*
* @param {Homepage_Save_Time_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_save_time_feature_3 = /** @type {((inputs?: Homepage_Save_Time_Feature_3Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Save_Time_Feature_3Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_save_time_feature_3(inputs)
	return en_homepage_save_time_feature_3(inputs)
});